export default __webpack_public_path__ + "static/media/Group1627.5fecee1e.png";